import { toast } from '@/components/toast';
import { translationGroupToDelete } from '@/pages/translation/state';
import { deleteTranslationGroup } from '@/services/api';
import { logger } from '@/services/logger';
import { ITranslationGroup } from '@d-id/types';
import { useMutation, useQueryClient } from 'react-query';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { GET_TRANSLATION_GROUPS_KEY, uploadingTranslationGroupsAtom } from './translationLibrary';

const getLoadingIdentifier = (group: ITranslationGroup | null) =>
    group ? `${group.name}-${group.target_languages.join('-')}`.toLowerCase() : '';

export const useDeleteTranslationGroup = (skipToast?: boolean) => {
    const queryClient = useQueryClient();
    const setUploadingTranslations = useSetRecoilState(uploadingTranslationGroupsAtom);
    const itemToDelete = useRecoilValue(translationGroupToDelete);

    return useMutation(deleteTranslationGroup, {
        onError: async (err: any, id) => {
            if (err.response.status !== 404) {
                logger.error(`Failed to delete translation group: ${id}`, { err });
                if (!skipToast) {
                    toast.error({ title: `Failed to delete videos`, toastId: `library-item-delete-error` });
                }
            }
        },
        onSuccess: async () => {
            const itemToDeleteIdentifier = getLoadingIdentifier(itemToDelete);
            setUploadingTranslations(currVal => currVal.filter(v => getLoadingIdentifier(v) !== itemToDeleteIdentifier));

            await queryClient.invalidateQueries(GET_TRANSLATION_GROUPS_KEY);
            if (!skipToast) {
                toast.success({ title: 'Your videos were successfully deleted' });
            }
        },
    });
};
